export { stirlerr } from './stirlerror';



// WEBPACK FOOTER //
// ./src/lib/stirling/index.ts